var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddTaskSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_12584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.875 0H93V23.25H34.875V0ZM34.875 34.875H93V58.125H34.875V34.875ZM34.875 69.75H93V93H34.875V69.75ZM17.4375 5.8125V17.4375H5.8125V5.8125H17.4375ZM23.25 0H0V23.25H23.25V0ZM17.4375 75.5625V87.1875H5.8125V75.5625H17.4375ZM23.25 69.75H0V93H23.25V69.75ZM30.8063 34.2938L27.3187 29.6437L22.0875 34.875H0V58.125H23.25V41.85L30.8063 34.2938ZM15.6938 40.6875L11.625 44.7562L6.975 40.6875H15.6938ZM5.8125 47.6625L11.0437 52.3125H5.8125V47.6625ZM17.4375 52.3125H12.2062L17.4375 47.0813V52.3125Z",
    fill: "#1F7E78"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_12584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 93,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTaskSvg);
export default __webpack_public_path__ + "static/media/AddTaskSvg.2aba4435bb543bb867ec2c4c9326ea5d.svg";
export { ForwardRef as ReactComponent };